import { Link } from 'react-router-dom'
import { Linkedin, Mail } from 'lucide-react'

export default function Footer() {
  const currentYear = new Date().getFullYear()

  return (
    <footer className="bg-dark-900 text-neutral-100 border-t border-neon-lime/20">
      <div className="container-custom py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-16">
          {/* Column 1: About */}
          <div>
            <h3 className="text-xl mb-4 tracking-tight">
              <span className="text-neon-lime">/mathos</span> consult
            </h3>
            <p className="text-neutral-300 mb-4 leading-relaxed">
              Strategic service design for positive impact
            </p>
            <p className="text-sm text-neutral-400">
              &copy; {currentYear} Mathos Consult Ltd. All rights reserved.
            </p>
          </div>

          {/* Column 2: Quick Links */}
          <div>
            <h4 className="text-lg mb-6">Quick Links</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-neutral-400 hover:text-neon-lime transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-neutral-400 hover:text-neon-pink transition-colors">
                  About
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-neutral-400 hover:text-neon-orange transition-colors">
                  Services
                </Link>
              </li>
              <li>
                <Link to="/approach" className="text-neutral-400 hover:text-neon-purple transition-colors">
                  Approach
                </Link>
              </li>
              <li>
                <Link to="/blog" className="text-neutral-400 hover:text-neon-yellow transition-colors">
                  Blog
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-neutral-400 hover:text-neon-lime transition-colors">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Column 3: Connect */}
          <div>
            <h4 className="text-lg mb-6">Connect</h4>
            <ul className="space-y-4">
              <li>
                <a
                  href="mailto:hello@mathosconsult.com"
                  className="text-neutral-400 hover:text-neon-lime transition-colors flex items-center gap-2 group"
                >
                  <Mail size={18} className="group-hover:text-neon-lime" />
                  hello@mathosconsult.com
                </a>
              </li>
              <li>
                <a
                  href="https://linkedin.com/company/mathosconsult"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-neutral-400 hover:text-neon-pink transition-colors flex items-center gap-2 group"
                >
                  <Linkedin size={18} className="group-hover:text-neon-pink" />
                  LinkedIn
                </a>
              </li>
              <li className="text-neutral-300">
                📍 UK-based
              </li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  )
}
